export const OtpDetails = () => {
  return [
    {
      field_name: "otp",
      label: "OTP",
      type: "number",
      isRequired: true,
      min: 6,
      max: 6,
    },
  ];
};
